import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.regexp.match";
import _construct from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/construct";
import _slicedToArray from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray";
import _toConsumableArray from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _classCallCheck from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _get from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/get";
import _inherits from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/element
 */
import Node from "./node";
import Text from "./text";
import TextProxy from "./textproxy";
import objectToMap from '@ckeditor/ckeditor5-utils/src/objecttomap';
import isIterable from '@ckeditor/ckeditor5-utils/src/isiterable';
import Matcher from "./matcher";
import { isPlainObject } from 'lodash-es';
/**
 * View element.
 *
 * The editing engine does not define a fixed semantics of its elements (it is "DTD-free").
 * This is why the type of the {@link module:engine/view/element~Element} need to
 * be defined by the feature developer. When creating an element you should use one of the following methods:
 *
 * * {@link module:engine/view/downcastwriter~DowncastWriter#createContainerElement `downcastWriter#createContainerElement()`}
 * in order to create a {@link module:engine/view/containerelement~ContainerElement},
 * * {@link module:engine/view/downcastwriter~DowncastWriter#createAttributeElement `downcastWriter#createAttributeElement()`}
 * in order to create a {@link module:engine/view/attributeelement~AttributeElement},
 * * {@link module:engine/view/downcastwriter~DowncastWriter#createEmptyElement `downcastWriter#createEmptyElement()`}
 * in order to create a {@link module:engine/view/emptyelement~EmptyElement}.
 * * {@link module:engine/view/downcastwriter~DowncastWriter#createUIElement `downcastWriter#createUIElement()`}
 * in order to create a {@link module:engine/view/uielement~UIElement}.
 * * {@link module:engine/view/downcastwriter~DowncastWriter#createEditableElement `downcastWriter#createEditableElement()`}
 * in order to create a {@link module:engine/view/editableelement~EditableElement}.
 *
 * Note that for view elements which are not created from the model, like elements from mutations, paste or
 * {@link module:engine/controller/datacontroller~DataController#set data.set} it is not possible to define the type of the element.
 * In such cases the {@link module:engine/view/upcastwriter~UpcastWriter#createElement `UpcastWriter#createElement()`} method
 * should be used to create generic view elements.
 *
 * @extends module:engine/view/node~Node
 */

var Element = /*#__PURE__*/function (_Node) {
  _inherits(Element, _Node);

  var _super = _createSuper(Element);

  /**
   * Creates a view element.
   *
   * Attributes can be passed in various formats:
   *
   *		new Element( 'div', { class: 'editor', contentEditable: 'true' } ); // object
   *		new Element( 'div', [ [ 'class', 'editor' ], [ 'contentEditable', 'true' ] ] ); // map-like iterator
   *		new Element( 'div', mapOfAttributes ); // map
   *
   * @protected
   * @param {String} name Node name.
   * @param {Object|Iterable} [attrs] Collection of attributes.
   * @param {module:engine/view/node~Node|Iterable.<module:engine/view/node~Node>} [children]
   * A list of nodes to be inserted into created element.
   */
  function Element(name, attrs, children) {
    var _this;

    _classCallCheck(this, Element);

    _this = _super.call(this);
    /**
     * Name of the element.
     *
     * @readonly
     * @member {String}
     */

    _this.name = name;
    /**
     * Map of attributes, where attributes names are keys and attributes values are values.
     *
     * @protected
     * @member {Map} #_attrs
     */

    _this._attrs = parseAttributes(attrs);
    /**
     * Array of child nodes.
     *
     * @protected
     * @member {Array.<module:engine/view/node~Node>}
     */

    _this._children = [];

    if (children) {
      _this._insertChild(0, children);
    }
    /**
     * Set of classes associated with element instance.
     *
     * @protected
     * @member {Set}
     */


    _this._classes = new Set();

    if (_this._attrs.has('class')) {
      // Remove class attribute and handle it by class set.
      var classString = _this._attrs.get('class');

      parseClasses(_this._classes, classString);

      _this._attrs.delete('class');
    }
    /**
     * Map of styles.
     *
     * @protected
     * @member {Map} module:engine/view/element~Element#_styles
     */


    _this._styles = new Map();

    if (_this._attrs.has('style')) {
      // Remove style attribute and handle it by styles map.
      parseInlineStyles(_this._styles, _this._attrs.get('style'));

      _this._attrs.delete('style');
    }
    /**
     * Map of custom properties.
     * Custom properties can be added to element instance, will be cloned but not rendered into DOM.
     *
     * @protected
     * @member {Map}
     */


    _this._customProperties = new Map();
    return _this;
  }
  /**
   * Number of element's children.
   *
   * @readonly
   * @type {Number}
   */


  _createClass(Element, [{
    key: "childCount",
    get: function get() {
      return this._children.length;
    }
    /**
     * Is `true` if there are no nodes inside this element, `false` otherwise.
     *
     * @readonly
     * @type {Boolean}
     */

  }, {
    key: "isEmpty",
    get: function get() {
      return this._children.length === 0;
    }
    /**
     * Checks whether this object is of the given.
     *
     *		element.is( 'element' ); // -> true
     *		element.is( 'node' ); // -> true
     *		element.is( 'view:element' ); // -> true
     *		element.is( 'view:node' ); // -> true
     *
     *		element.is( 'model:element' ); // -> false
     *		element.is( 'documentSelection' ); // -> false
     *
     * Assuming that the object being checked is an element, you can also check its
     * {@link module:engine/view/element~Element#name name}:
     *
     *		element.is( 'img' ); // -> true if this is an <img> element
     *		element.is( 'element', 'img' ); // -> same as above
     *		text.is( 'img' ); -> false
     *
     * {@link module:engine/view/node~Node#is Check the entire list of view objects} which implement the `is()` method.
     *
     * @param {String} type Type to check when `name` parameter is present.
     * Otherwise, it acts like the `name` parameter.
     * @param {String} [name] Element name.
     * @returns {Boolean}
     */

  }, {
    key: "is",
    value: function is(type) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var cutType = type.replace(/^view:/, '');

      if (!name) {
        return cutType == 'element' || cutType == this.name || _get(_getPrototypeOf(Element.prototype), "is", this).call(this, type);
      } else {
        return cutType == 'element' && name == this.name;
      }
    }
    /**
     * Gets child at the given index.
     *
     * @param {Number} index Index of child.
     * @returns {module:engine/view/node~Node} Child node.
     */

  }, {
    key: "getChild",
    value: function getChild(index) {
      return this._children[index];
    }
    /**
     * Gets index of the given child node. Returns `-1` if child node is not found.
     *
     * @param {module:engine/view/node~Node} node Child node.
     * @returns {Number} Index of the child node.
     */

  }, {
    key: "getChildIndex",
    value: function getChildIndex(node) {
      return this._children.indexOf(node);
    }
    /**
     * Gets child nodes iterator.
     *
     * @returns {Iterable.<module:engine/view/node~Node>} Child nodes iterator.
     */

  }, {
    key: "getChildren",
    value: function getChildren() {
      return this._children[Symbol.iterator]();
    }
    /**
     * Returns an iterator that contains the keys for attributes. Order of inserting attributes is not preserved.
     *
     * @returns {Iterable.<String>} Keys for attributes.
     */

  }, {
    key: "getAttributeKeys",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function getAttributeKeys() {
      return regeneratorRuntime.wrap(function getAttributeKeys$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(this._classes.size > 0)) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return 'class';

            case 3:
              if (!(this._styles.size > 0)) {
                _context.next = 6;
                break;
              }

              _context.next = 6;
              return 'style';

            case 6:
              return _context.delegateYield(this._attrs.keys(), "t0", 7);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, getAttributeKeys, this);
    })
    /**
     * Returns iterator that iterates over this element's attributes.
     *
     * Attributes are returned as arrays containing two items. First one is attribute key and second is attribute value.
     * This format is accepted by native `Map` object and also can be passed in `Node` constructor.
     *
     * @returns {Iterable.<*>}
     */

  }, {
    key: "getAttributes",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function getAttributes() {
      return regeneratorRuntime.wrap(function getAttributes$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.delegateYield(this._attrs.entries(), "t0", 1);

            case 1:
              if (!(this._classes.size > 0)) {
                _context2.next = 4;
                break;
              }

              _context2.next = 4;
              return ['class', this.getAttribute('class')];

            case 4:
              if (!(this._styles.size > 0)) {
                _context2.next = 7;
                break;
              }

              _context2.next = 7;
              return ['style', this.getAttribute('style')];

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, getAttributes, this);
    })
    /**
     * Gets attribute by key. If attribute is not present - returns undefined.
     *
     * @param {String} key Attribute key.
     * @returns {String|undefined} Attribute value.
     */

  }, {
    key: "getAttribute",
    value: function getAttribute(key) {
      if (key == 'class') {
        if (this._classes.size > 0) {
          return _toConsumableArray(this._classes).join(' ');
        }

        return undefined;
      }

      if (key == 'style') {
        if (this._styles.size > 0) {
          var styleString = '';

          var _iterator = _createForOfIteratorHelper(this._styles),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _step$value = _slicedToArray(_step.value, 2),
                  property = _step$value[0],
                  value = _step$value[1];

              styleString += "".concat(property, ":").concat(value, ";");
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return styleString;
        }

        return undefined;
      }

      return this._attrs.get(key);
    }
    /**
     * Returns a boolean indicating whether an attribute with the specified key exists in the element.
     *
     * @param {String} key Attribute key.
     * @returns {Boolean} `true` if attribute with the specified key exists in the element, false otherwise.
     */

  }, {
    key: "hasAttribute",
    value: function hasAttribute(key) {
      if (key == 'class') {
        return this._classes.size > 0;
      }

      if (key == 'style') {
        return this._styles.size > 0;
      }

      return this._attrs.has(key);
    }
    /**
     * Checks if this element is similar to other element.
     * Both elements should have the same name and attributes to be considered as similar. Two similar elements
     * can contain different set of children nodes.
     *
     * @param {module:engine/view/element~Element} otherElement
     * @returns {Boolean}
     */

  }, {
    key: "isSimilar",
    value: function isSimilar(otherElement) {
      if (!(otherElement instanceof Element)) {
        return false;
      } // If exactly the same Element is provided - return true immediately.


      if (this === otherElement) {
        return true;
      } // Check element name.


      if (this.name != otherElement.name) {
        return false;
      } // Check number of attributes, classes and styles.


      if (this._attrs.size !== otherElement._attrs.size || this._classes.size !== otherElement._classes.size || this._styles.size !== otherElement._styles.size) {
        return false;
      } // Check if attributes are the same.


      var _iterator2 = _createForOfIteratorHelper(this._attrs),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              key = _step2$value[0],
              value = _step2$value[1];

          if (!otherElement._attrs.has(key) || otherElement._attrs.get(key) !== value) {
            return false;
          }
        } // Check if classes are the same.

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(this._classes),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var className = _step3.value;

          if (!otherElement._classes.has(className)) {
            return false;
          }
        } // Check if styles are the same.

      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var _iterator4 = _createForOfIteratorHelper(this._styles),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              property = _step4$value[0],
              _value = _step4$value[1];

          if (!otherElement._styles.has(property) || otherElement._styles.get(property) !== _value) {
            return false;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return true;
    }
    /**
     * Returns true if class is present.
     * If more then one class is provided - returns true only when all classes are present.
     *
     *		element.hasClass( 'foo' ); // Returns true if 'foo' class is present.
     *		element.hasClass( 'foo', 'bar' ); // Returns true if 'foo' and 'bar' classes are both present.
     *
     * @param {...String} className
     */

  }, {
    key: "hasClass",
    value: function hasClass() {
      for (var _len = arguments.length, className = new Array(_len), _key = 0; _key < _len; _key++) {
        className[_key] = arguments[_key];
      }

      for (var _i = 0, _className = className; _i < _className.length; _i++) {
        var name = _className[_i];

        if (!this._classes.has(name)) {
          return false;
        }
      }

      return true;
    }
    /**
     * Returns iterator that contains all class names.
     *
     * @returns {Iterable.<String>}
     */

  }, {
    key: "getClassNames",
    value: function getClassNames() {
      return this._classes.keys();
    }
    /**
     * Returns style value for given property.
     * Undefined is returned if style does not exist.
     *
     * @param {String} property
     * @returns {String|undefined}
     */

  }, {
    key: "getStyle",
    value: function getStyle(property) {
      return this._styles.get(property);
    }
    /**
     * Returns iterator that contains all style names.
     *
     * @returns {Iterable.<String>}
     */

  }, {
    key: "getStyleNames",
    value: function getStyleNames() {
      return this._styles.keys();
    }
    /**
     * Returns true if style keys are present.
     * If more then one style property is provided - returns true only when all properties are present.
     *
     *		element.hasStyle( 'color' ); // Returns true if 'border-top' style is present.
     *		element.hasStyle( 'color', 'border-top' ); // Returns true if 'color' and 'border-top' styles are both present.
     *
     * @param {...String} property
     */

  }, {
    key: "hasStyle",
    value: function hasStyle() {
      for (var _len2 = arguments.length, property = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        property[_key2] = arguments[_key2];
      }

      for (var _i2 = 0, _property = property; _i2 < _property.length; _i2++) {
        var name = _property[_i2];

        if (!this._styles.has(name)) {
          return false;
        }
      }

      return true;
    }
    /**
     * Returns ancestor element that match specified pattern.
     * Provided patterns should be compatible with {@link module:engine/view/matcher~Matcher Matcher} as it is used internally.
     *
     * @see module:engine/view/matcher~Matcher
     * @param {Object|String|RegExp|Function} patterns Patterns used to match correct ancestor.
     * See {@link module:engine/view/matcher~Matcher}.
     * @returns {module:engine/view/element~Element|null} Found element or `null` if no matching ancestor was found.
     */

  }, {
    key: "findAncestor",
    value: function findAncestor() {
      for (var _len3 = arguments.length, patterns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        patterns[_key3] = arguments[_key3];
      }

      var matcher = _construct(Matcher, patterns);

      var parent = this.parent;

      while (parent) {
        if (matcher.match(parent)) {
          return parent;
        }

        parent = parent.parent;
      }

      return null;
    }
    /**
     * Returns the custom property value for the given key.
     *
     * @param {String|Symbol} key
     * @returns {*}
     */

  }, {
    key: "getCustomProperty",
    value: function getCustomProperty(key) {
      return this._customProperties.get(key);
    }
    /**
     * Returns an iterator which iterates over this element's custom properties.
     * Iterator provides `[ key, value ]` pairs for each stored property.
     *
     * @returns {Iterable.<*>}
     */

  }, {
    key: "getCustomProperties",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function getCustomProperties() {
      return regeneratorRuntime.wrap(function getCustomProperties$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.delegateYield(this._customProperties.entries(), "t0", 1);

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, getCustomProperties, this);
    })
    /**
     * Returns identity string based on element's name, styles, classes and other attributes.
     * Two elements that {@link #isSimilar are similar} will have same identity string.
     * It has the following format:
     *
     *		'name class="class1,class2" style="style1:value1;style2:value2" attr1="val1" attr2="val2"'
    	 *
     * For example:
     *
     *		const element = writer.createContainerElement( 'foo', {
     *			banana: '10',
     *			apple: '20',
     *			style: 'color: red; border-color: white;',
     *			class: 'baz'
     *		} );
     *
     *		// returns 'foo class="baz" style="border-color:white;color:red" apple="20" banana="10"'
     *		element.getIdentity();
     *
     * NOTE: Classes, styles and other attributes are sorted alphabetically.
     *
     * @returns {String}
     */

  }, {
    key: "getIdentity",
    value: function getIdentity() {
      var classes = Array.from(this._classes).sort().join(',');
      var styles = Array.from(this._styles).map(function (i) {
        return "".concat(i[0], ":").concat(i[1]);
      }).sort().join(';');
      var attributes = Array.from(this._attrs).map(function (i) {
        return "".concat(i[0], "=\"").concat(i[1], "\"");
      }).sort().join(' ');
      return this.name + (classes == '' ? '' : " class=\"".concat(classes, "\"")) + (styles == '' ? '' : " style=\"".concat(styles, "\"")) + (attributes == '' ? '' : " ".concat(attributes));
    }
    /**
     * Clones provided element.
     *
     * @protected
     * @param {Boolean} [deep=false] If set to `true` clones element and all its children recursively. When set to `false`,
     * element will be cloned without any children.
     * @returns {module:engine/view/element~Element} Clone of this element.
     */

  }, {
    key: "_clone",
    value: function _clone() {
      var deep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var childrenClone = [];

      if (deep) {
        var _iterator5 = _createForOfIteratorHelper(this.getChildren()),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var child = _step5.value;
            childrenClone.push(child._clone(deep));
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      } // ContainerElement and AttributeElement should be also cloned properly.


      var cloned = new this.constructor(this.name, this._attrs, childrenClone); // Classes and styles are cloned separately - this solution is faster than adding them back to attributes and
      // parse once again in constructor.

      cloned._classes = new Set(this._classes);
      cloned._styles = new Map(this._styles); // Clone custom properties.

      cloned._customProperties = new Map(this._customProperties); // Clone filler offset method.
      // We can't define this method in a prototype because it's behavior which
      // is changed by e.g. toWidget() function from ckeditor5-widget. Perhaps this should be one of custom props.

      cloned.getFillerOffset = this.getFillerOffset;
      return cloned;
    }
    /**
     * {@link module:engine/view/element~Element#_insertChild Insert} a child node or a list of child nodes at the end of this node
     * and sets the parent of these nodes to this element.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#insert
     * @protected
     * @param {module:engine/view/item~Item|Iterable.<module:engine/view/item~Item>} items Items to be inserted.
     * @fires module:engine/view/node~Node#change
     * @returns {Number} Number of appended nodes.
     */

  }, {
    key: "_appendChild",
    value: function _appendChild(items) {
      return this._insertChild(this.childCount, items);
    }
    /**
     * Inserts a child node or a list of child nodes on the given index and sets the parent of these nodes to
     * this element.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#insert
     * @protected
     * @param {Number} index Position where nodes should be inserted.
     * @param {module:engine/view/item~Item|Iterable.<module:engine/view/item~Item>} items Items to be inserted.
     * @fires module:engine/view/node~Node#change
     * @returns {Number} Number of inserted nodes.
     */

  }, {
    key: "_insertChild",
    value: function _insertChild(index, items) {
      this._fireChange('children', this);

      var count = 0;
      var nodes = normalize(items);

      var _iterator6 = _createForOfIteratorHelper(nodes),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var node = _step6.value;

          // If node that is being added to this element is already inside another element, first remove it from the old parent.
          if (node.parent !== null) {
            node._remove();
          }

          node.parent = this;

          this._children.splice(index, 0, node);

          index++;
          count++;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return count;
    }
    /**
     * Removes number of child nodes starting at the given index and set the parent of these nodes to `null`.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#remove
     * @protected
     * @param {Number} index Number of the first node to remove.
     * @param {Number} [howMany=1] Number of nodes to remove.
     * @fires module:engine/view/node~Node#change
     * @returns {Array.<module:engine/view/node~Node>} The array of removed nodes.
     */

  }, {
    key: "_removeChildren",
    value: function _removeChildren(index) {
      var howMany = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      this._fireChange('children', this);

      for (var i = index; i < index + howMany; i++) {
        this._children[i].parent = null;
      }

      return this._children.splice(index, howMany);
    }
    /**
     * Adds or overwrite attribute with a specified key and value.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#setAttribute
     * @protected
     * @param {String} key Attribute key.
     * @param {String} value Attribute value.
     * @fires module:engine/view/node~Node#change
     */

  }, {
    key: "_setAttribute",
    value: function _setAttribute(key, value) {
      value = String(value);

      this._fireChange('attributes', this);

      if (key == 'class') {
        parseClasses(this._classes, value);
      } else if (key == 'style') {
        parseInlineStyles(this._styles, value);
      } else {
        this._attrs.set(key, value);
      }
    }
    /**
     * Removes attribute from the element.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#removeAttribute
     * @protected
     * @param {String} key Attribute key.
     * @returns {Boolean} Returns true if an attribute existed and has been removed.
     * @fires module:engine/view/node~Node#change
     */

  }, {
    key: "_removeAttribute",
    value: function _removeAttribute(key) {
      this._fireChange('attributes', this); // Remove class attribute.


      if (key == 'class') {
        if (this._classes.size > 0) {
          this._classes.clear();

          return true;
        }

        return false;
      } // Remove style attribute.


      if (key == 'style') {
        if (this._styles.size > 0) {
          this._styles.clear();

          return true;
        }

        return false;
      } // Remove other attributes.


      return this._attrs.delete(key);
    }
    /**
     * Adds specified class.
     *
     *		element._addClass( 'foo' ); // Adds 'foo' class.
     *		element._addClass( [ 'foo', 'bar' ] ); // Adds 'foo' and 'bar' classes.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#addClass
     * @protected
     * @param {Array.<String>|String} className
     * @fires module:engine/view/node~Node#change
     */

  }, {
    key: "_addClass",
    value: function _addClass(className) {
      var _this2 = this;

      this._fireChange('attributes', this);

      className = Array.isArray(className) ? className : [className];
      className.forEach(function (name) {
        return _this2._classes.add(name);
      });
    }
    /**
     * Removes specified class.
     *
     *		element._removeClass( 'foo' );  // Removes 'foo' class.
     *		element._removeClass( [ 'foo', 'bar' ] ); // Removes both 'foo' and 'bar' classes.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#removeClass
     * @protected
     * @param {Array.<String>|String} className
     * @fires module:engine/view/node~Node#change
     */

  }, {
    key: "_removeClass",
    value: function _removeClass(className) {
      var _this3 = this;

      this._fireChange('attributes', this);

      className = Array.isArray(className) ? className : [className];
      className.forEach(function (name) {
        return _this3._classes.delete(name);
      });
    }
    /**
     * Adds style to the element.
     *
     *		element._setStyle( 'color', 'red' );
     *		element._setStyle( {
     *			color: 'red',
     *			position: 'fixed'
     *		} );
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#setStyle
     * @protected
     * @param {String|Object} property Property name or object with key - value pairs.
     * @param {String} [value] Value to set. This parameter is ignored if object is provided as the first parameter.
     * @fires module:engine/view/node~Node#change
     */

  }, {
    key: "_setStyle",
    value: function _setStyle(property, value) {
      this._fireChange('attributes', this);

      if (isPlainObject(property)) {
        var keys = Object.keys(property);

        for (var _i3 = 0, _keys = keys; _i3 < _keys.length; _i3++) {
          var key = _keys[_i3];

          this._styles.set(key, property[key]);
        }
      } else {
        this._styles.set(property, value);
      }
    }
    /**
     * Removes specified style.
     *
     *		element._removeStyle( 'color' );  // Removes 'color' style.
     *		element._removeStyle( [ 'color', 'border-top' ] ); // Removes both 'color' and 'border-top' styles.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#removeStyle
     * @protected
     * @param {Array.<String>|String} property
     * @fires module:engine/view/node~Node#change
     */

  }, {
    key: "_removeStyle",
    value: function _removeStyle(property) {
      var _this4 = this;

      this._fireChange('attributes', this);

      property = Array.isArray(property) ? property : [property];
      property.forEach(function (name) {
        return _this4._styles.delete(name);
      });
    }
    /**
     * Sets a custom property. Unlike attributes, custom properties are not rendered to the DOM,
     * so they can be used to add special data to elements.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#setCustomProperty
     * @protected
     * @param {String|Symbol} key
     * @param {*} value
     */

  }, {
    key: "_setCustomProperty",
    value: function _setCustomProperty(key, value) {
      this._customProperties.set(key, value);
    }
    /**
     * Removes the custom property stored under the given key.
     *
     * @see module:engine/view/downcastwriter~DowncastWriter#removeCustomProperty
     * @protected
     * @param {String|Symbol} key
     * @returns {Boolean} Returns true if property was removed.
     */

  }, {
    key: "_removeCustomProperty",
    value: function _removeCustomProperty(key) {
      return this._customProperties.delete(key);
    }
    /**
     * Returns block {@link module:engine/view/filler filler} offset or `null` if block filler is not needed.
     *
     * @abstract
     * @method module:engine/view/element~Element#getFillerOffset
     */

  }]);

  return Element;
}(Node); // Parses attributes provided to the element constructor before they are applied to an element. If attributes are passed
// as an object (instead of `Map`), the object is transformed to the map. Attributes with `null` value are removed.
// Attributes with non-`String` value are converted to `String`.
//
// @param {Object|Map} attrs Attributes to parse.
// @returns {Map} Parsed attributes.


export { Element as default };

function parseAttributes(attrs) {
  if (isPlainObject(attrs)) {
    attrs = objectToMap(attrs);
  } else {
    attrs = new Map(attrs);
  }

  var _iterator7 = _createForOfIteratorHelper(attrs),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var _step7$value = _slicedToArray(_step7.value, 2),
          key = _step7$value[0],
          value = _step7$value[1];

      if (value === null) {
        attrs.delete(key);
      } else if (typeof value != 'string') {
        attrs.set(key, String(value));
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return attrs;
} // Parses inline styles and puts property - value pairs into styles map.
// Styles map is cleared before insertion.
//
// @param {Map.<String, String>} stylesMap Map to insert parsed properties and values.
// @param {String} stylesString Styles to parse.


function parseInlineStyles(stylesMap, stylesString) {
  // `null` if no quote was found in input string or last found quote was a closing quote. See below.
  var quoteType = null;
  var propertyNameStart = 0;
  var propertyValueStart = 0;
  var propertyName = null;
  stylesMap.clear(); // Do not set anything if input string is empty.

  if (stylesString === '') {
    return;
  } // Fix inline styles that do not end with `;` so they are compatible with algorithm below.


  if (stylesString.charAt(stylesString.length - 1) != ';') {
    stylesString = stylesString + ';';
  } // Seek the whole string for "special characters".


  for (var i = 0; i < stylesString.length; i++) {
    var char = stylesString.charAt(i);

    if (quoteType === null) {
      // No quote found yet or last found quote was a closing quote.
      switch (char) {
        case ':':
          // Most of time colon means that property name just ended.
          // Sometimes however `:` is found inside property value (for example in background image url).
          if (!propertyName) {
            // Treat this as end of property only if property name is not already saved.
            // Save property name.
            propertyName = stylesString.substr(propertyNameStart, i - propertyNameStart); // Save this point as the start of property value.

            propertyValueStart = i + 1;
          }

          break;

        case '"':
        case '\'':
          // Opening quote found (this is an opening quote, because `quoteType` is `null`).
          quoteType = char;
          break;

        case ';':
          {
            // Property value just ended.
            // Use previously stored property value start to obtain property value.
            var propertyValue = stylesString.substr(propertyValueStart, i - propertyValueStart);

            if (propertyName) {
              // Save parsed part.
              stylesMap.set(propertyName.trim(), propertyValue.trim());
            }

            propertyName = null; // Save this point as property name start. Property name starts immediately after previous property value ends.

            propertyNameStart = i + 1;
            break;
          }
      }
    } else if (char === quoteType) {
      // If a quote char is found and it is a closing quote, mark this fact by `null`-ing `quoteType`.
      quoteType = null;
    }
  }
} // Parses class attribute and puts all classes into classes set.
// Classes set s cleared before insertion.
//
// @param {Set.<String>} classesSet Set to insert parsed classes.
// @param {String} classesString String with classes to parse.


function parseClasses(classesSet, classesString) {
  var classArray = classesString.split(/\s+/);
  classesSet.clear();
  classArray.forEach(function (name) {
    return classesSet.add(name);
  });
} // Converts strings to Text and non-iterables to arrays.
//
// @param {String|module:engine/view/item~Item|Iterable.<String|module:engine/view/item~Item>}
// @returns {Iterable.<module:engine/view/node~Node>}


function normalize(nodes) {
  // Separate condition because string is iterable.
  if (typeof nodes == 'string') {
    return [new Text(nodes)];
  }

  if (!isIterable(nodes)) {
    nodes = [nodes];
  } // Array.from to enable .map() on non-arrays.


  return Array.from(nodes).map(function (node) {
    if (typeof node == 'string') {
      return new Text(node);
    }

    if (node instanceof TextProxy) {
      return new Text(node.data);
    }

    return node;
  });
}